import { Col, Button } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, PageLink }) => {
  // Define a function to handle the click event
  const handleClick = (e) => {
    // Prevent the default behavior of opening the link
    e.preventDefault();
    // Confirm with the user if they want to leave the current page
    const confirm = window.confirm("You are about to leave the current page. Do you want to continue?");
    // If the user confirms, open the link in a new tab
    if (confirm) {
      window.open(PageLink);
    }
  };

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} className="proj-img" alt="alt" />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span> <br />
          {/* Use a button component with an onclick handler */}
          <Button variant="primary" onClick={handleClick}>
            Visit Page
          </Button>
        </div>
      </div>
    </Col>
  );
};
